import { Link } from "react-router-dom";

export const Footer = () => {
    return (
        <footer className="border-t border-indigo-400/25 bg-indigo-950 py-16" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 sm:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-10">
                <div>
                    <div className="mb-4 flex items-center gap-4">
                        <div className="bg-white px-3 py-1.5 shadow-[0_4px_16px_rgba(0,0,0,0.35)]"><img src="/assets/logo.png" alt="Planet Valet logo" className="h-10 w-auto" /></div>
                        <div className="bg-white px-3 py-1.5 shadow-[0_4px_16px_rgba(0,0,0,0.35)]"><img src="/assets/kisho-logo.png" alt="KISHO Ceramic Coatings logo" className="h-10 w-auto" data-testid="footer-kisho-logo" /></div>
                    </div>
                    <p className="text-sm font-light text-white/70 max-w-sm leading-relaxed mb-5">
                        Independent motorhome detailing, built on years of word of mouth. Book online and I'll confirm personally.
                    </p>
                    <address className="not-italic text-sm leading-relaxed text-white/70" data-testid="footer-address">
                        Unit B2, 46 Holton Road<br />
                        Holton Heath Industrial Park<br />
                        Poole BH16 6LT
                    </address>
                </div>
                <div className="flex flex-col gap-3 text-xs tracking-[0.2em] uppercase font-semibold text-white/70">
                    <a href="tel:+447481776151" className="hover:text-blue-300 transition-colors" data-testid="footer-phone-link">Call 07481 776151</a>
                    <button onClick={() => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" })} className="text-left hover:text-blue-300 transition-colors" data-testid="footer-book-link">Book a valet</button>
                    <Link to="/maxmats" className="hover:text-blue-300 transition-colors" data-testid="footer-maxmats-link">Maxmats cab mats</Link>
                    <Link to="/admin/login" className="hover:text-blue-300 transition-colors" data-testid="footer-admin-link">Owner login</Link>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-6 sm:px-10 mt-12 pt-8 border-t border-indigo-400/25">
                <p className="text-xs text-white/60 font-light">© {new Date().getFullYear()} Planet Valet. All rights reserved.</p>
            </div>
        </footer>
    );
};
